import { useState } from "react";

/**
 * useFormValidation
 * @description A hook to validate form fields
 * @example
 * const { errors, validate } = useFormValidation([{
 *   name: "textValue",
 *   value: textValue,
 *   rule: (v) => v.length,
 * }])
 *
 * @param {Array} fields
 * @param {String} fields[].name
 * @param {String} fields[].value
 * @param {Function} fields[].rule
 * @param {String} fields[].message
 * @returns {Object} errors
 * @returns {Function} validate
 */
export const useFormValidation = (fields) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errors = {};

    fields.forEach((field) => {
      if (!field.rule(field.value)) {
        errors[field.name] = field.message || "Invalid field";
      }
    });

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return {
    errors,
    validate,
  };
};
